import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AuthService } from "../auth.service";
import { NgxSpinnerService } from "ngx-spinner";
import Swal from "sweetalert2";

@Component({
  selector: "app-forgot-password",
  templateUrl: "./forgot-password.component.html",
  styleUrls: ["./forgot-password.component.scss"]
})
export class ForgotPasswordComponent implements OnInit {
  forgotPasswordForm: FormGroup;
  formSubmitted: boolean = false;
  user = { user_id: null, otp: null };

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private authService: AuthService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit() {
    this.initialiseForms();
    this.user = {
      user_id: this.route.snapshot.params["id"],
      otp: this.route.snapshot.params["token"]
    };

  }

  initialiseForms() {
    this.forgotPasswordForm = this.fb.group({
      password: ["", [Validators.required]],
      confirmPassword: ["", [Validators.required]]
    });
  }

  resetPassword() {
    this.formSubmitted = true;
    if (this.forgotPasswordForm.valid) {
      let req = {
        userId: this.user.user_id,
        otp: this.user.otp,
        password: this.forgotPasswordForm.controls["password"].value
      };
      this.spinner.show();
      this.authService.resetPassword(req).subscribe(res => {
        this.spinner.hide();
        this.forgotPasswordForm.reset();
        Swal.fire("Success", res.msg || "Successfully Reset Your Password !!", "success");
        this.router.navigate(["auth/login"]);

      });
    }
  }
}
